const MINUTE_MS = 60_000;
const MINUTES_PER_HOUR = 60;
const MINUTES_PER_DAY = 24 * MINUTES_PER_HOUR;

/** "2h 10m" style, to the minute while under a day and to the hour after, so a long-standing alert does not flicker every minute. */
export function formatAge(milliseconds: number): string {
  const minutes = Math.max(0, Math.floor(milliseconds / MINUTE_MS));
  if (minutes < 1) return '<1m';
  if (minutes < MINUTES_PER_HOUR) return `${minutes}m`;
  if (minutes < MINUTES_PER_DAY) return `${Math.floor(minutes / MINUTES_PER_HOUR)}h ${minutes % MINUTES_PER_HOUR}m`;
  const days = Math.floor(minutes / MINUTES_PER_DAY);
  return `${days}d ${Math.floor((minutes % MINUTES_PER_DAY) / MINUTES_PER_HOUR)}h`;
}

/** How long an alert has been (or was) raised: to now while it is unresolved, to its resolution once it is, so a closed alert stops ageing. */
export function alertAge(alert: { raisedAt: string; resolvedAt: string | null }, now: Date): string {
  const end = alert.resolvedAt ? new Date(alert.resolvedAt) : now;
  return formatAge(end.getTime() - new Date(alert.raisedAt).getTime());
}
